import burgerWebp from './images/optimized/burger.webp';
import burgerFallback from './images/optimized/burger.png';
import tacosWebp from './images/optimized/tacos.webp';
import tacosFallback from './images/optimized/tacos.png';
import crepesWebp from './images/optimized/crepes.webp';
import crepesFallback from './images/optimized/crepes.png';
import boissonWebp from './images/optimized/boisson.webp';
import boissonFallback from './images/optimized/boisson.png';
import jusNaturelsWebp from './images/optimized/jus-naturels-promo.webp';
import jusNaturelsFallback from './images/optimized/jus-naturels-promo.png';
import heroBgWebp from './images/optimized/hero-bg-pattern.webp';
import heroBgFallback from './images/optimized/hero-bg-pattern.jpg';
import heroWomanWebp from './images/optimized/hero-woman.webp';
import heroWomanFallback from './images/optimized/hero-woman.png';
import heroEmblemWebp from './images/optimized/hero-emblem.webp';
import heroEmblemFallback from './images/optimized/hero-emblem.png';
import brandLogoWebp from './images/optimized/brand-logo.webp';
import brandLogoFallback from './images/optimized/brand-logo.png';
import jusMangueWebp from './images/optimized/jus-mangue.webp';
import jusMangueFallback from './images/optimized/jus-mangue.png';
import jusGoyaveWebp from './images/optimized/jus-goyave.webp';
import jusGoyaveFallback from './images/optimized/jus-goyave.png';
import jusCorossolWebp from './images/optimized/jus-corossol.webp';
import jusCorossolFallback from './images/optimized/jus-corossol.png';
import jusBissapWebp from './images/optimized/jus-bissap.webp';
import jusBissapFallback from './images/optimized/jus-bissap.png';
import jusAnanasWebp from './images/optimized/jus-ananas.webp';
import jusAnanasFallback from './images/optimized/jus-ananas.png';
import jusBaobabWebp from './images/optimized/jus-baobab.webp';
import jusBaobabFallback from './images/optimized/jus-baobab.png';
import boissonsBouteillesWebp from './images/optimized/boissons-bouteilles.webp';
import boissonsBouteillesFallback from './images/optimized/boissons-bouteilles.png';
import packAnniversaireWebp from './images/optimized/pack-anniversaire.webp';
import packAnniversaireFallback from './images/optimized/pack-anniversaire.png';
import packYouAndMeWebp from './images/optimized/pack-you-and-me.webp';
import packYouAndMeFallback from './images/optimized/pack-you-and-me.png';
import packSurpriseWebp from './images/optimized/pack-surprise.webp';
import packSurpriseFallback from './images/optimized/pack-surprise.png';
import packFamilleWebp from './images/optimized/pack-famille.webp';
import packFamilleFallback from './images/optimized/pack-famille.png';
import dowhileBurgerWebp from './images/optimized/product-tiers/dowhile-burger-tier-5.webp';
import dowhileBurgerFallback from './images/optimized/product-tiers/dowhile-burger-tier-5.png';
import chickenBurgerWebp from './images/optimized/product-tiers/chicken-burger-tier-5.webp';
import chickenBurgerFallback from './images/optimized/product-tiers/chicken-burger-tier-5.png';
import tacosXxlWebp from './images/optimized/product-tiers/tacos-xxl-tier-5.webp';
import tacosXxlFallback from './images/optimized/product-tiers/tacos-xxl-tier-5.png';
import tacosPouletWebp from './images/optimized/product-tiers/tacos-poulet-tier-5.webp';
import tacosPouletFallback from './images/optimized/product-tiers/tacos-poulet-tier-5.png';
import crepeNutellaWebp from './images/optimized/product-tiers/crepe-nutella-tier-4.webp';
import crepeNutellaFallback from './images/optimized/product-tiers/crepe-nutella-tier-4.png';
import crepeSaleeWebp from './images/optimized/product-tiers/crepe-salee-tier-4.webp';
import crepeSaleeFallback from './images/optimized/product-tiers/crepe-salee-tier-4.png';

export function imageAsset(webp, fallback) {
  return { webp, fallback };
}

const heroWoman = imageAsset(heroWomanWebp, heroWomanFallback);

export const heroImages = {
  background: imageAsset(heroBgWebp, heroBgFallback),
  woman: heroWoman,
  emblem: imageAsset(heroEmblemWebp, heroEmblemFallback),
};

const resolveUrl = (mod) => (mod && mod.default) || mod;

// Diaporama du hero : hero-woman (slide 1, obligatoire) + hero-woman-2, hero-woman-3…
// Il suffit de déposer hero-woman-2.png / hero-woman-3.png dans src/assets/images/
// puis de lancer `npm run optimize-images` : les slides sont récupérées automatiquement.
function loadWomanSlides() {
  const slides = [heroWoman];
  try {
    const ctx = require.context('./images/optimized', false, /hero-woman-\d+\.(webp|png)$/);
    const byIndex = {};
    ctx.keys().forEach((key) => {
      const match = key.match(/hero-woman-(\d+)\.(webp|png)$/);
      if (!match) return;
      const [, index, ext] = match;
      byIndex[index] = byIndex[index] || {};
      byIndex[index][ext] = resolveUrl(ctx(key));
    });
    Object.keys(byIndex)
      .sort((a, b) => Number(a) - Number(b))
      .forEach((index) => {
        const entry = byIndex[index];
        if (entry.webp && entry.png) slides.push(imageAsset(entry.webp, entry.png));
      });
  } catch (error) {
    // require.context indisponible (ex. environnement de test) — on garde l'image unique.
  }
  return slides;
}

export const heroWomanSlides = loadWomanSlides();

export const brandLogo = imageAsset(brandLogoWebp, brandLogoFallback);

export const menuPhotos = {
  burgers: imageAsset(burgerWebp, burgerFallback),
  tacos: imageAsset(tacosWebp, tacosFallback),
  crepes: imageAsset(crepesWebp, crepesFallback),
  boissons: imageAsset(boissonWebp, boissonFallback),
  boissonsAccueil: imageAsset(boissonsBouteillesWebp, boissonsBouteillesFallback),
  jusNaturels: imageAsset(jusNaturelsWebp, jusNaturelsFallback),
};

// Image dédiée par jus naturel (clé = id du jus dans menuData).
export const juicePhotos = {
  'jus-baobab': imageAsset(jusBaobabWebp, jusBaobabFallback),
  'jus-mangue': imageAsset(jusMangueWebp, jusMangueFallback),
  'jus-goyave': imageAsset(jusGoyaveWebp, jusGoyaveFallback),
  'jus-corossol': imageAsset(jusCorossolWebp, jusCorossolFallback),
  'jus-bissap': imageAsset(jusBissapWebp, jusBissapFallback),
  'jus-ananas': imageAsset(jusAnanasWebp, jusAnanasFallback),
};

export const packPhotos = {
  'pack-anniversaire': imageAsset(packAnniversaireWebp, packAnniversaireFallback),
  'pack-you-and-me': imageAsset(packYouAndMeWebp, packYouAndMeFallback),
  'pack-surprise': imageAsset(packSurpriseWebp, packSurpriseFallback),
  'pack-famille': imageAsset(packFamilleWebp, packFamilleFallback),
};

export const productComposerPhotos = {
  'dowhile-burger': imageAsset(dowhileBurgerWebp, dowhileBurgerFallback),
  'chicken-burger': imageAsset(chickenBurgerWebp, chickenBurgerFallback),
  'tacos-xxl': imageAsset(tacosXxlWebp, tacosXxlFallback),
  'tacos-poulet': imageAsset(tacosPouletWebp, tacosPouletFallback),
  'crepe-nutella': imageAsset(crepeNutellaWebp, crepeNutellaFallback),
  'crepe-salee': imageAsset(crepeSaleeWebp, crepeSaleeFallback),
};

export default menuPhotos;
